module.exports = __webpack_public_path__ + "static/media/Stonk-Stock-Page.1d4113ac.png";